import * as React from 'react';
import * as _ from 'underscore';

import { IContentInfo } from '../../ts/models/IContentInfo';
import { TOTAL_CARD_WIDTH } from './CardView/CardViewStyles';
import { ContentCardWrapper } from './CardView/ContentCardWrapper';
import { SpacesSiteUrls } from './SpacesSiteUrls';


const urls = new SpacesSiteUrls({ siteUrlName: '' });

export interface CardDragPreviewProps {
  readonly content: IContentInfo;
}

export const CardDragPreview = (props: CardDragPreviewProps) => {
  return (
    <div style={{backgroundColor: 'white', boxShadow: '0 8px 12px 4px rgba(0, 0, 0, 0.15)', width: TOTAL_CARD_WIDTH}}>
      <ContentCardWrapper
        addContentFavorite={_.noop}
        content={props.content}
        getContentDetail={_.noop}
        inDatasourceConnectionsSubspace={false}
        inFavoritesSpace={false}
        inProjectSpace={false}
        inRecentsSpace={false}
        inWorkbookDatasourcesSubspace={false}
        removeContentFavorite={_.noop}
        reorderItem={_.noop}
        callReorderItem={_.noop}
        showActionMenu={true}
        urls={urls}
        forDragPreview={true}
        spaceInfo={undefined}
        dragInProgress={false}
        setIsDragging={_.noop}
      />
    </div>
  );
};

